<!--
 * @Description: 文件说明
 * @Author: XSYX
 * @Date: 2026-06-22 09:56:21
 * @LastEditors: XSYX
 * @LastEditTime: 2026-06-24 09:52:01
 * @FilePath: \smkp_粤河\src\App.vue
-->
<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

export default {
  name: "App",
  created() {
    // this.wxConfig();
  },
  methods: {
    //重置微信权限
    wxConfig() {
        // .post(window.xheader + "/api/Invoice/GetWxConfig", { url: "http://invoice.yuehego.com" })
      // 
      this.$axios
        .post(window.xheader + "/api/Invoice/GetWxConfig", { url: encodeURIComponent(window.location.href.split('#')[0]) })
        .then((data) => {
          window.access_token = data.access_token;
          window.wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ["chooseInvoiceTitle"],
          });
          window.wx.ready(() => {
            // console.log('微信功能正常');
          });
          window.wx.error((res) => {
            console.log('微信功能异常', res);
          });
        })
        .catch(() => {
          Toast("微信功能异常");
        });
    },
  },
};
</script>
